<template>
    <div class="container-fluid">
        <div class="container-fluid">
            <div class="row mb-1">
                <div class="col-sm-5 text-start pb-1">
                    <span class="badge rounded-pill pull-left mt-1 py-2 px-4 text-white" style="font-size:18px; background:ForestGreen">
                        <b>Lab Release : อนุญาติให้คลินิกต้นทางเข้าถึงผลแล็บ</b>
                    </span>
                </div>
            </div>
            <!-- Option : Checkbox / Dropdown / Radio -->
            <div class="row mb-1">
                <div class="col-md-6 col-lg-3 text-start pb-1">
                    <div class="form-check form-check-inline mx-3 pt-2" title="แสดงรายการที่รับเข้าห้องแล็บ">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="1" v-model="status1Lab">
                      <label class="form-check-label" for="inlineCheckbox1"><b>Lab</b> </label>
                    </div>
                    <div class="form-check form-check-inline mx-3 pt-2" title="แสดงรายการที่ป้อนผลแล้วรออนุมัติ">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="2" v-model="status2Res">
                      <label class="form-check-label" for="inlineCheckbox2"><b>Resulted</b> </label>
                    </div>
                    <div class="form-check form-check-inline mx-2 " title="แสดงรายการที่ป้อนผลและอนุมัติแล้ว">
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox3" value="3" v-model="status3App">
                      <label class="form-check-label" for="inlineCheckbox3"><b>AP</b> </label>
                    </div>
                </div>
            </div>
            <hr style="height:2px;border-width:0;color:black;background-color:black;">
            <div class="row">
                <div class="col-sm">
                    <div class="row">
                        <div class="col-sm-4">
                          <!-- สาขาแล็บ -->
                          <div class="input-group input-group-sm">
                              <div class="input-group-prepend">
                                <span class="input-group-text" style="width:120px;">สาขา* :</span>
                              </div>
                              <select class="form-select form-select-sm" ref="BranchID" id="BranchID" name="BranchID" v-model="branchID" >
                                  <option disabled value="">Please select one</option>
                                  <option v-for="item in dataBranchlists" :key="item.BranchID" :value="item.BranchID">{{ item.BranchName }}</option>
                              </select>
                          </div>
                        </div>
                        <div class="col-sm">
                          <!-- วันที่ใบสั่งตรวจ -->
                          <div class="input-group input-group-sm mb-1">
                            <div class="input-group-prepend">
                                <span class="input-group-text" style="width:120px;">วันที่เอกสาร</span>
                            </div>
                            <v-date-picker mode="date" v-model="dateFm" :masks="masks" title="วันที่เอกสารเริ่มต้น">
                                <template v-slot="{ inputValue, inputEvents }">
                                    <input name="dateFm" ref="dateFm" style="width:120px;"
                                    class="bg-white border px-2 py-1 rounded"
                                    :value="inputValue"
                                    v-on="inputEvents"
                                    />
                                </template>
                            </v-date-picker>
                            <v-date-picker mode="date" v-model="dateTo" :masks="masks" title="วันที่เอกสารสิ้นสุด">
                                <template v-slot="{ inputValue, inputEvents }">
                                    <input name="dateTo" ref="dateTo" style="width:120px;"
                                    class="bg-white border px-2 py-1 rounded"
                                    :value="inputValue"
                                    v-on="inputEvents"
                                    />
                                </template>
                            </v-date-picker>
                            <button type="button" class="btn btn-info btn-sm text-white mx-2" @click="getData()">ดึงข้อมูล</button>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
              <div class="col-sm-7">
                <!-- ตารางใบสั่งตรวจ สถานะใหม่และป้อนผล ตามเงื่อนไขสาขาและวันที่เอกสาร -->
                <LabRelease1View :datalists="datalists" :key="countRefresh"
                    @onBackPageAfterSaveEvent="backPageAfterSave"
                    @onViewResultEvent="viewResultPage"></LabRelease1View>
              </div>
              <div class="col-sm-5 my-div-p0 card" style="background-color:ForestGreen">
                <LabRelease2Dtl :key="countDtlRefresh"
                  :dataROHead="curRecord"></LabRelease2Dtl>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

import LabRelease1View from './LabRelease1View.vue'
import LabRelease2Dtl from './LabRelease2Dtl.vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  masks: {
    input: 'YYYY-MM-DD'
  },
  name: 'LabPrint',
  data () {
    return {
      // เงื่อนไขสำหรับดึงข้อมูลหน้าหลัก
      branchID: 0,
      dateFm: new Date(),
      dateTo: new Date(),
      // status0New: false,
      // status1Lab: false,
      status1Lab: true,
      status2Res: false,
      status3App: true,

      countRefresh: 0,
      countDtlRefresh: 0,
      datalists: null,
      curRecord: null,
      PatName: '',
      action: 'new',
      // รายชื่อ พนง ในระบบ สำหรับเลือกใน Header Table
      dataOfficerlists: null,
      // รายชื่อสาขาทั้งหมด สำหรับเลือกใน Header Table
      dataBranchlists: null
    }
  },
  created () {
    // Initial Value
    this.getOfficerData()
    this.getBranchData()
  },
  mounted () {
    this.branchID = this.globalBranchID
    // ดึงข้อมูลรายการใบสั่งตรวจ
    this.getData()
  },
  components: {
    LabRelease1View, LabRelease2Dtl
  },
  methods: {
    backPageAfterSave () {
      this.$nextTick(() => {
        $('#myLabAppvTable').DataTable()
      })
      // Refresh ตารางใบสั่งตรวจ สถานะเปลี่ยน
      this.getData()
      this.viewResultPage(null)
    },
    backPage () {
      this.$nextTick(() => {
        $('#myLabAppvTable').DataTable()
      })
    },
    // เปิดหน้าต่างแสดงผลแล็บ
    viewResultPage (row) {
      // console.log('callback to refresh!!!')
      this.curRecord = row
      this.countDtlRefresh++
    },
    getBranchData () {
      MyApiClient.get('getdata/branch_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          this.dataBranchlists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getOfficerData () {
      MyApiClient.get('getdata/officers_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          // console.log(resp.data.response)
          this.dataOfficerlists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getData () {
      // -------- Date From -----------
      var d = this.dateFm
      var YYYY = d.getFullYear().toString()
      var MM = ''
      var DD = ''
      if (d.getMonth() + 1 < 10) {
        MM = '0' + (d.getMonth() + 1).toString()
      } else {
        MM = (d.getMonth() + 1).toString()
      }
      if (d.getDate() < 10) {
        DD = '0' + d.getDate().toString()
      } else {
        DD = d.getDate().toString()
      }
      var docDateFm = YYYY + '-' + MM + '-' + DD
      // -------- Date To -----------
      d = this.dateTo
      YYYY = d.getFullYear().toString()
      MM = ''
      DD = ''
      if (d.getMonth() + 1 < 10) {
        MM = '0' + (d.getMonth() + 1).toString()
      } else {
        MM = (d.getMonth() + 1).toString()
      }
      if (d.getDate() < 10) {
        DD = '0' + d.getDate().toString()
      } else {
        DD = d.getDate().toString()
      }
      var docDateTo = YYYY + '-' + MM + '-' + DD
      var BranchID = this.branchID
      var Status1 = -1 // 1-Lab
      var Status2 = -1 // 2-Resulted
      var Status3 = -1 // 3-Approve
      if (this.status1Lab) {
        Status1 = 1 // 1-Lab
      }
      if (this.status2Res) {
        Status2 = 2 // 2-Resulted
      }
      if (this.status3App) {
        Status3 = 3 // 3-Approve
      }
      MyApiClient.get('getdata/labrequest_where_release.php?C1=' + this.globalCorpID + '&BranchID=' + BranchID +
        '&DocDateFm=' + docDateFm + '&DocDateTo=' + docDateTo +
        '&Status1=' + Status1 + '&Status2=' + Status2 + '&Status3=' + Status3)
        .then((resp) => {
          // console.log(resp.data.response)
          this.datalists = resp.data.response
          if (this.datalists == null) {
            Swal.fire({ icon: 'info', text: 'ไม่มีข้อมูล', showConfirmButton: false, timer: 1000 })
          }
          // setTimeout(function () { this.$refs.myBranchTable.DataTable() }, 0)
          // console.log('on update ตาราง')
          setTimeout(function () { $('#myLabAppvTable').DataTable() }, 0)
          this.countRefresh++
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>
.my-div-p0 {
  padding: 0px;
}
<style>

</style>
